// src/components/Loading/Loading.jsx
import React from 'react';
import './Loading.css';

function Loading({ message = "A carregar..." }) {
  return (
    <div className="loading-container">
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-icon">
          <i className="bi bi-mortarboard-fill"></i>
        </div>
      </div>
      <div className="loading-text">
        <span>{message}</span>
        <div className="loading-dots">
          <span>.</span><span>.</span><span>.</span>
        </div>
      </div>
      <div className="loading-progress">
        <div className="progress-bar-fill"></div>
      </div>
    </div>
  );
}

export default Loading;